import React from 'react';
import { Link } from 'react-router-dom';

/**
 * SaveTime component - Simple section with client value proposition
 * Displays the key benefit statement with contact CTA
 */
const SaveTime = () => {
  return (
    <section id="save-time" className="section save-time reveal">
      <div className="save-time-content">
        <h2>Save Time. Cut Costs. Scale Faster.</h2>
        <p className="save-time-quote">
          <em>"Our clients typically see a 40% reduction in manual tasks and recoup their entire investment within months—so you can get back to what matters: growing your business"</em>
        </p>
        <p className="save-time-cta-text">
          Contact us to know more about us or to design software solutions specifically for your business needs.
        </p>
        <Link to="/contact" className="save-time-btn">
          Contact Now
        </Link>
      </div>
    </section>
  );
};

export default SaveTime;